"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ActionTypes = _interopRequireDefault(require("pricing-pages-unified-ui/constants/ActionTypes"));

var RequestStatus = _interopRequireWildcard(require("pricing-pages-unified-ui/constants/RequestStatus"));

var initialState = {
  requestStatus: RequestStatus.UNINITIALIZED,
  users: null
};

var usersInPortal = function usersInPortal() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _ActionTypes.default.USERS_IN_PORTAL_REQUESTED:
      return {
        requestStatus: RequestStatus.PENDING
      };

    case _ActionTypes.default.USERS_IN_PORTAL_RECEIVED:
      return {
        requestStatus: RequestStatus.SUCCEEDED,
        users: payload
      };

    case _ActionTypes.default.USERS_IN_PORTAL_FAILED:
      return {
        requestStatus: RequestStatus.FAILED
      };

    default:
      return state;
  }
};

var _default = usersInPortal;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/reducers/UsersInPortal.js
// module id = 532
// module chunks = 5 6